import { render, staticRenderFns } from "./FunnelsByCategory.vue?vue&type=template&id=99c0793e"
import script from "./FunnelsByCategory.vue?vue&type=script&lang=js"
export * from "./FunnelsByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports